import { getDb } from '../db';
import type { Abbrev } from '../../core/types';

/** `code` is the primary key, so an upsert with an existing code replaces it. */
export const abbrevRepo = {
  async all(): Promise<Abbrev[]> {
    const db = await getDb();
    return (await db.getAll('abbrevs')).sort((a, b) => a.code.localeCompare(b.code, 'de-CH'));
  },

  async get(code: string): Promise<Abbrev | undefined> {
    const db = await getDb();
    return db.get('abbrevs', code);
  },

  async upsert(abbrev: Abbrev): Promise<void> {
    const db = await getDb();
    await db.put('abbrevs', abbrev);
  },

  async remove(code: string): Promise<void> {
    const db = await getDb();
    await db.delete('abbrevs', code);
  },
};
